import { render, staticRenderFns } from "./THR.vue?vue&type=template&id=6a871b64"
import script from "./THR.vue?vue&type=script&lang=js"
export * from "./THR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports